import request from '@/utils/httpRequest';

export default class WxPayService {

  /**
   * 获取订单信息和token
   * @param {Object} ids
   */
  getOrderInfo(ids) {
    return request({
      url: '/v3/api/app/web/getOrderInfo',
      method: 'post',
      params: {ids: ids}
    });
  }

  /**
   * 获取微信用户信息
   * @param {Object} data
   */
  getWxUserInfo(data) {
    return request({
      url: '/v3/api/app/web/getWxUserInfo',
      method: 'post',
      params: data
    });
  }

  /**
   * 获取支付配置
   * @param {Object} data
   */
  getWXPay(data) {
    return request({
      url: '/v3/api/app/web/wxpay',
      method: 'post',
      params: data
    });
  }

  /**
   * 创建订单
   */
  createOrder(orderno, feeNormId, orderInfo){
    return request({
    	url: '/v3/api/app/web/createOrder',
    	method: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
    	data: {orderno: orderno, feeNormId: feeNormId, orderInfo: orderInfo}
    })
  }

  /**
   * 删除订单
   * @param {Object} orderno
   */
  deleteOrder(orderno){
    return request({
    	url: '/v3/api/app/web/deleteOrder',
    	method: 'post',
    	params: {orderno: orderno}
    })
  }

  /**
   * 查询订单信息
   * @param {Object} data
   */
  orderQuery(data){
  	return request({
  		url: '/v3/api/app/web/orderQuery',
  		method: 'post',
  		params: data
  	})
  }

}
